const EmailJsConfig = {
  SERVICE_ID: "service_gbmcjfd",
  TEMPLATE_ID_ContactForm: "template_8gwevgl",
  USER_ID: "sy1a-LD7M9WiMPTvz",
};

export default EmailJsConfig;
